<template>
  <div class="location-meta left">
    <h3 class="location-name">{{nameLookup[location.slug]}}</h3>
    <p :style="`font-size:${fontSize}`">{{
      location.acf.location_address1
    }}<br>{{
      location.acf.location_city}}, {{location.acf.location_state
    }}<br>{{
      location.acf.location_phone
    }}</p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {

  name: 'TogoMenuLocation',
  props : {
    location : {
      type: Object,
      required : true,
      default : () => {}
    }
  },
  data () {
    return {
      nameLookup : {
        'maple-street' : 'Uptown',
        'dauphine-street' : 'Bywater',
        'magazine-street' : 'Magazine',
      }
    }
  },
  computed : {
    ...mapState(["fontSize"]),
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Menus/TogoMenuLocation.vue